import { registerStoreItem, DISABLED_ACTION_COMMIT } from 'utils/storeCreator'
import { teacherListOption, teacherList } from 'api/consult'

function toFixedZero(str) {
  if ((str + '').length === 1) {
    return '0' + str
  }
  return str
}

const filterDataWayType = {
  title: '咨询方式',
  type: 'way_type',
  list: [
    {
      name: '不限',
      type: 'way_type',
      value: '',
      active: true
    },
    {
      name: '视频',
      type: 'way_type',
      value: 'shipinjiage'
    },
    {
      name: '面对面',
      type: 'way_type',
      value: 'mianjiage'
    },
    {
      name: '语音',
      type: 'way_type',
      value: 'yuyinjiage'
    }
  ].map(v => ({
    ...v,
    stat: '咨询方式-' + v.name
  }))
}

const filterDataGender = {
  title: '性别',
  type: 'gender',
  list: [
    {
      name: '不限',
      active: true,
      type: 'gender',
      value: ''
    },
    {
      value: 1,
      name: '女性',
      type: 'gender'
    },
    {
      name: '男性',
      value: 2,
      type: 'gender'
    }
  ].map(v => ({
    ...v,
    stat: '性别-' + v.name
  }))
}

const filterDataFeature = {
  title: '咨询师特色',
  type: 'feature',
  list: [
    // {
    //   name: '半价咨询',
    //   type: 'feature',
    //   alowMultiple: true,
    //   value: 'half_price'
    // },
    {
      name: '海外留学',
      type: 'feature',
      alowMultiple: true,
      value: 'oversea'
    },
    {
      name: '提供预沟通',
      type: 'pre_consult',
      // alowMultiple: true,
      value: 'on'
    }
  ].map(v => ({
    ...v,
    stat: '咨询师特色-' + v.name
  }))
}

const filterDataAge = {
  title: '年龄',
  type: 'age',
  list: [
    {
      name: '不限',
      type: 'age',
      value: '',
      active: true
    },
    {
      name: '60后',
      value: '1960',
      type: 'age'
    },
    {
      name: '70后',
      value: '1970',
      type: 'age'
    },
    {
      name: '80后',
      value: '1980',
      type: 'age'
    },
    {
      name: '90后',
      value: '1990',
      type: 'age'
    }
  ].map(v => ({
    ...v,
    stat: '年龄-' + v.name
  }))
}

const priceData = [
  {
    value: '',
    name: '不限',
    type: 'price',
    active: true
  },
  {
    value: '0-200',
    name: '200元以下',
    type: 'price'
  },
  {
    value: '200-300',
    name: '200-300元',
    type: 'price'
  },
  {
    value: '300-500',
    name: '300-500元',
    type: 'price'
  },
  {
    value: '500-1000',
    name: '500-1000元',
    type: 'price'
  },
  {
    value: '1000-9999',
    name: '1000元以上',
    type: 'price'
  }
].map(v => ({
  ...v,
  stat: '价格-' + v.name
}))

const preConsultData = [
  {
    value: '',
    name: '全部',
    type: 'pre_consult',
    active: true
  },
  {
    value: 'on',
    name: '已开通',
    type: 'pre_consult'
  }
]

// http://112.124.122.87:8084/index.php?m=story&f=view&storyID=1215
function parseRoute(route, tags, areas) {
  const { channel_id, cid } = route.query
  const channelId = cid || channel_id || ''
  let tag = route.query.tag || ''
  let city = route.query.city || ''
  let province = ''
  let title = channelId ? '' : '心理咨询_心理咨询师_心理医生-壹心理'
  let keywords = '心理咨询,心理咨询师'
  let description =
    '壹心理心理咨询师频道，遵循严格的心理咨询师审核标准，已邀请500位心理咨询师和心理医生入驻，通过视频、语音、咨询室等方式为您提供婚恋、家庭、儿童、职场等心理咨询服务。'

  const { pathMatch } = route.params
  if (pathMatch) {
    const [tagIdOrCity, _tag] = pathMatch.split('-')
    if (_tag) {
      // consult/list-{城市/省份拼音}-{分类名称}/
      city = decodeURIComponent(tagIdOrCity)

      const isATag = tags.find(v => v.value === parseInt(_tag))
      tag = isATag.value

      title = `${city}${isATag.name}心理咨询_${city}${isATag.name}心理咨询师-壹心理`
      keywords = `${isATag.name}心理咨询,${isATag.name}心理咨询师`
      description = `壹心理${city}${isATag.name}心理咨询师频道，通过视频、语音、咨询室等方式，为您提供${city}${isATag.name}心理咨询服务。`
    } else {
      const isATag = tags.find(v => v.value === parseInt(tagIdOrCity))
      if (isATag) {
        // consult/list-{分类名称}/
        tag = isATag.value
        title = `${isATag.name}心理咨询_${isATag.name}心理咨询师_${isATag.name}心理医生-壹心理 `
        keywords = `${isATag.name}心理咨询,${isATag.name}心理咨询师`
        description = `壹心理${isATag.name}心理咨询师频道，多位${isATag.name}心理咨询师和${isATag.name}心理医生入驻，通过视频、语音、咨询室等方式为您提供${isATag.name}心理咨询服务。`
      } else {
        // 可能是省或者是市
        city = decodeURIComponent(tagIdOrCity)

        title = `${city}心理咨询_${city}心理咨询师_${city}心理医生-壹心理`
        keywords = `${city}心理咨询,${city}心理咨询师`
        description = `壹心理${city}心理咨询师频道，多位${city}心理咨询师和${city}心理医生入驻，通过视频、语音、咨询室等方式为身在${city}的您提供婚恋、家庭、儿童、职场等心理咨询服务。`
      }
    }

    if (city) {
      const isProvince = areas.find(v => v.name === city)
      if (isProvince) {
        province = isProvince.value
        city = isProvince.list[0].value
      }
    }
  }
  console.log(tag, city, province)
  return {
    tdk: {
      title,
      description,
      keywords
    },
    channelId,
    selectObj: {
      tag,
      city,
      province
    }
  }
}

let store = registerStoreItem({
  store: {
    namespaced: true,
    state: () => ({
      teacherList: [],
      // https://yapi.xinli001.com/project/22/interface/api/4106
      options: {
        size: 10,
        sort: '',
        page: 1,
        category: '',
        province: '',
        city: '',
        price: '',
        way_type: '',
        tag: 0,
        feature: '',
        age: '',
        gender: '',
        pre_consult: '',
        channel_id: '',
        consult_schedule: '',
        get_type: ''
      }
    }),

    mutations: {
      setOptions(state, options) {
        // eslint-disable-next-line
        const { randomSort, customFetch, ...other } = options
        state.options = Object.assign(
          {
            page: 1
          },
          state.options,
          other
        )
      },
      setTeacherList(state, { list, page }) {
        if (!list) return
        state.teacherList =
          page === 1 ? [...list] : [...state.teacherList, ...list]
        state.options.page = page
      }
    },
    actions: {
      fetchTeacherList({ commit, state }, payload = {}) {
        const { randomSort, customFetch, ...other } = payload
        const finalOptions = {
          ...state.options,
          ...other
        }
        return (customFetch ? customFetch : teacherList)({
          selectObj: finalOptions
        }).then(res => {
          if (res.code === 0) {
            let list = res.data
            if (randomSort) {
              list = list.sort((a, b) => {
                if (a.sort || b.sort) {
                  return (b.sort || 0) - (a.sort || 0)
                }
                return Math.random() > 0.5 ? -1 : 1
              })
            }
            // console.log(list.map(v => v.sort).join(','))
            commit('setTeacherList', {
              list,
              page: finalOptions.page
            })
            return res
          }
        })
      },
      initData({ dispatch, commit }, route) {
        // const { route } = rootState
        const { channel_id, cid } = route.query
        const channelId = cid || channel_id || ''

        return dispatch('fetchSelectOption', {
          channelId: channelId
        })
          .then(res => {
            const { tags, areas } = res.data
            const { tdk, selectObj } = parseRoute(route, tags, areas)
            commit('setMeta', tdk, { root: true })
            if (channelId) {
              selectObj.province = '' // 渠道列表只显示热门城市
            }
            commit('setOptions', {
              page: 1,
              channel_id: channelId,
              ...selectObj
            })
          })
          .catch(e => {
            console.log('expertList prefetch hook error:', e)
          })
      },

      updateTeacherList({ commit, dispatch }, options = {}) {
        commit('setOptions', options)
        return dispatch('fetchTeacherList', options)
      }
    },

    getters: {
      parsedSelectOption(state, getters, rootState) {
        console.log(`rootState`, rootState.route.name)
        const days = [0, 1]
          .map(c => {
            let day = new Date()
            day.setTime(day.getTime() + 24 * 60 * 60 * 1000 * c)
            return (
              toFixedZero(day.getFullYear()) +
              '-' +
              toFixedZero(day.getMonth() + 1) +
              '-' +
              toFixedZero(day.getDate())
            )
          })
          .join(',')

        const sorts = [
          {
            name: '默认',
            type: 'sort',
            value: '',
            stat: '排序-默认'
          },
          {
            name: '今明可约',
            type: 'consult_schedule',
            value: days,
            stat: '排序-今明可约'
          },
          {
            name: '预约最多',
            type: 'sort',
            value: 'zxnum',
            stat: '排序-预约最多'
          },
          {
            name: '低价优先',
            type: 'sort',
            value: 'price',
            stat: '排序-低价优先'
          },
          {
            name: '最新入驻',
            type: 'sort',
            value: 'jointime',
            stat: '排序-最新入驻'
          }
        ]

        const { areas = [], tags, labels } = state.selectOption

        const { province, city, tag, channel_id } = state.options

        const getHref = (area, tag) => {
          if (rootState.route.name === 'consultExpertList') {
            const base = `/consult/${channel_id ? 'channel' : 'list'}`
            const _area = area ? `-${area}` : ''
            const _tag = tag ? `-${tag}` : ''
            let href = `${base}${_area}${_tag}`

            if (channel_id) {
              href += `?cid=${channel_id}`
            }

            return href
          } else {
            return 'javascript:void(0);'
          }
        }

        const _areas = areas.map(v => {
          return {
            ...v,
            href: getHref(v.value, tag),
            stat: '省份-' + v.name,
            list: v.list.map(c => {
              return {
                ...c,
                href: getHref(c.value, tag),
                stat: '城市-' + v.name
              }
            })
          }
        })

        const _tags = tags.map(v => {
          return {
            ...v,
            href: getHref(province || city, v.value),
            stat: '分类-' + v.name
          }
        })

        return {
          sorts,
          filters: channel_id
            ? [filterDataWayType, filterDataGender]
            : [
                filterDataWayType,
                filterDataGender,
                filterDataFeature,
                filterDataAge
              ],
          prices: priceData,
          areas: channel_id ? _areas[0]?.list : _areas,
          tags: _tags,
          labels,
          preConsult: preConsultData,
          genders: filterDataGender.list,
          waytypes: filterDataWayType.list
        }
      }
    }
  },

  name: 'selectOption',
  api: teacherListOption,
  handle: res => {
    const { code, data } = res
    // const { channelId } = params
    if (code === 0) {
      return data
    } else {
      return DISABLED_ACTION_COMMIT
    }
  },
  defaultValue: {
    areas: [],
    labels: {},
    tags: []
  }
})

export default {
  name: 'consultListCommon',
  store
}
